import routeName from '@/router/constant';
import code from './codeList';
import aplCatlCode from '@/json/aplCatlCode';

/**
 * 申請項目清單
 * code: 該申請項目之代號
 * routeName: 該申請項目之起始頁面
 * editRouteName: 該申請項目之編輯之起始頁面
 */
const serviceRoutes = [
    {
        /** 保單借款 */
        code: 'Pon4300',
        routeName: routeName.LOAN_SELECT_ACCOUNT,
        editRouteName: routeName.LOAN_SELECT_ACCOUNT,
    },
    {
        /** 申請電子通知單 */
        code: 'multiENotify',
        routeName: routeName.MULTI_ENOTIFY_TERMS,
        editRouteName: routeName.MULTI_ENOTIFY,
    },
    {
        /** 申請金融機構轉帳電子化繳費授權 */
        code: code.ACH,
        routeName: routeName.AUTH_METHODS,
        editRouteName: routeName.AUTH_METHODS,
    },
    {
        /** 申請自行繳費 */
        code: code.MULTI_PAY_CHANGE,
        routeName: routeName.PAY_OWN_TERMS,
        editRouteName: routeName.PAY_OWN_POLICY,
    },
    {
        /** 信用卡效期延長 */
        code: code.CREDIT_CARD_EXP,
        routeName: routeName.CREDITCARD_POLICY,
        editRouteName: routeName.CREDITCARD_POLICY,
    },
    {
        /** 申請信用卡授權 */
        code: code.CREDIT_CARD_AUTH,
        routeName: routeName.CREDIT_CARD_AUTH_TERMS,
        editRouteName: routeName.CREDIT_CARD_AUTH_POLICY,
    },
    {
        /** 631要保人聯絡資料 */
        code: 'BD',
        routeName: routeName.PROPOSER_INFO_BY_USER,
        editRouteName: routeName.PROPOSER_INFO_BY_USER,
    },
    // 保單之下的變更項目
    {
        /** 投資屬性問卷 */
        code: 'IQ',
        routeName: routeName.QUESTIONNAIRE,
        editRouteName: routeName.QUESTIONNAIRE,
    }, {
        /** 減少保單帳戶價值準備金說明 */
        code: 'AE',
        routeName: routeName.WITHDRAW_POLICY_TERMS,
        editRouteName: routeName.WITHDRAW_POLICY,
    }, {
        /** 指定扣取每月費用之順序 */
        code: 'AF',
        routeName: routeName.VU07,
        editRouteName: routeName.VU07,
    }, {
        /** 投資配息/提解給付方式變更 */
        code: 'AG',
        routeName: routeName.INVEST_DIVIDEND_PAY_WAY,
        editRouteName: routeName.INVEST_DIVIDEND_PAY_WAY,
    }, {
        /** 目標/計畫/每期保費暨配置比例/繳別變更 */
        code: 'A1',
        routeName: routeName.PREMIUM_TERMS,
        editRouteName: routeName.PREMIUM,
    }, {
        /** 保費緩繳 */
        code: 'A2',
        routeName: routeName.DELAY_PAYMENT,
        editRouteName: routeName.DELAY_PAYMENT,
    }, {
        /** 定期定額投資金額說明 */
        code: 'A4',
        routeName: routeName.VALUE_AVERAGING_TERMS,
        editRouteName: routeName.VALUE_AVERAGING,
    }, {
        /** 單筆增額/不定期投資金額申請 */
        code: 'A5',
        routeName: routeName.ONE_TIME_INVEST_TERMS,
        editRouteName: routeName.ONE_TIME_INVEST,
    }, {
        /** 投資標的轉換 */
        code: 'A6',
        routeName: routeName.TRANSFORM_TERMS,
        editRouteName: routeName.TRANSFORM_EXPORT,
    }, {
        /** 部分投資終止 */
        code: 'A7',
        routeName: routeName.TERMINATE_TERMS,
        editRouteName: routeName.TERMINATE,
    }, {
        /** 新台幣貨幣帳戶定期定額投資金額轉換 */
        code: 'A9',
        routeName: routeName.NTD_AVERAGING_TERMS,
        editRouteName: routeName.NTD_AVERAGING,
    }, {
        /** 指定聯絡人 */
        code: 'BA',
        routeName: routeName.ASSIGN_CONTACT_DESCRIPTION,
        editRouteName: routeName.ASSIGN_CONTACT,
    }, {
        /** 地址/電話/Email變更 */
        code: 'BC',
        routeName: routeName.PROPOSER_INFO,
        editRouteName: routeName.PROPOSER_INFO,
    }, {
        /** 繳別變更 */
        code: 'B1',
        routeName: routeName.PAYMENT_PERIOD_TERMS,
        editRouteName: routeName.PAYMENT_PERIOD,
    }, {
        /** 電子通知單服務 */
        code: 'B4',
        routeName: routeName.ENOTIFY_DESCRIPTION,
        editRouteName: routeName.ENOTIFY,
    }, {
        /** 要保人指定匯款帳戶 */
        code: 'B5',
        routeName: routeName.PH_BANK_ACC,
        editRouteName: routeName.PH_BANK_ACC,
    }, {
        /** 受益人匯款帳號約定/變更 */
        code: 'B6',
        routeName: routeName.BENE_FI_BANK_ACC,
        editRouteName: routeName.BENE_FI_BANK_ACC,
    }, {
        /** 受益人匯款帳號約定/變更 */
        code: 'B7',
        routeName: routeName.INSURED_BANK_ACC,
        editRouteName: routeName.INSURED_BANK_ACC,
    }, {
        /** 清償自動墊繳保費本息 */
        code: 'C2',
        routeName: routeName.PAY_OFF_INTEREST_TERMS,
        editRouteName: routeName.PAY_OFF_INTEREST,
    }, {
        /** 保險單補發 */
        code: 'B3',
        routeName: routeName.POLICY_APPLY,
        editRouteName: routeName.POLICY_APPLY,
    }, {
        /** 自行繳費申請 */
        code: 'D1',
        routeName: routeName.PAY_CHANGE,
        editRouteName: routeName.PAY_CHANGE,
    }, {
        /** 保單繳清 */
        code: 'C1',
        routeName: routeName.POLICY_PAID_UP,
        editRouteName: routeName.POLICY_PAID_UP,
    }, {
        /** ISAB減少年金保單價值準備金 */
        code: 'AB',
        routeName: routeName.VALUE_RESERVE_ISAB,
        editRouteName: routeName.VALUE_RESERVE_ISAB,
    }, {
        /** 自動墊繳意願變更 */
        code: 'C4',
        routeName: routeName.AUTO_PREM_LOAN,
        editRouteName: routeName.AUTO_PREM_LOAN,
    }, {
        /** 紅利/增值回饋分享金給付方式變更 */
        code: 'B2',
        routeName: routeName.DIVIDEND_CHANGE,
        editRouteName: routeName.DIVIDEND_CHANGE,
    }, {
        /** 保單帳戶價值通知方式變更 */
        code: 'AD',
        routeName: routeName.POLICY_VAL_NOTIFY,
        editRouteName: routeName.POLICY_VAL_NOTIFY,
    }, {
        /** 年金給付變更 */
        code: 'AC',
        routeName: routeName.ANNUITY_CHANGE,
        editRouteName: routeName.ANNUITY_CHANGE,
    }, {
        code: aplCatlCode.APPLICANT_CHANGE,
        routeName: routeName.CLOUD_E_COUNTER_APPLICANT_CHANGE_INFO,
        editRouteName: routeName.CLOUD_E_COUNTER_APPLICANT_CHANGE_INFO,
    }, {
        code: aplCatlCode.BENEIFCIARY,
        routeName: routeName.CLOUD_E_BENEFICIARY_INFO,
        editRouteName: routeName.CLOUD_E_BENEFICIARY_INFO,
    }, {
        code: aplCatlCode.APPLICANT_INSURED_NAME_CHANGE,
        routeName: routeName.CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_INFO,
        editRouteName: routeName.CLOUD_E_COUNTER_APPLICANT_INSURED_NAME_CHANGE_INFO,
    },
    {
        code: aplCatlCode.LOAN,
        routeName: routeName.CLOUD_E_COUNTER_LOAN_NOTICE,
        editRouteName: routeName.CLOUD_E_COUNTER_LOAN_NOTICE,
    },

];

serviceRoutes.forEach(i => {
    Object.freeze(i);
});
export default serviceRoutes;
